<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="打印机详情"
      width="80%"
      @close="close"
    >
      <el-row>
        <el-col :span="5">打印机名称:</el-col>
        <el-col :span="19">{{ showForm.title }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="12">设备编号:{{ showForm.basic.key }}</el-col>
        <el-col :span="12">设备秘钥:{{ showForm.basic.secret }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">打印机说明：</el-col>
        <el-col :span="15">
          <div
            class="rich-box"
            v-html="showForm.basic && showForm.basic.text"
          ></div>
        </el-col>
      </el-row>
      <template #footer>
        <el-button type="primary" @click="bindPrinter" style="float: left">
          绑定打印机
        </el-button>
        <el-button style="float: left" type="warning" @click="unBindPrinter">
          解绑打印机
        </el-button>
        <el-button style="float: left" type="warning" @click="testPrinter">
          打印测试
        </el-button>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
    <el-dialog title="测试打印机" v-model="testVisible" width="60%">
      <el-form ref="testForm" label-width="120px" :model="testForm">
        <el-form-item label="测试内容" prop="content">
          <el-input
            v-model="testForm.content"
            type="textarea"
            class="fix-width"
            :rows="6"
            placeholder="请输入测试内容"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="testVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitTest">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  findPrinter,
  bindPrinter,
  unBindPrinter,
  testPrinter,
} from '@/api/settings'
export default {
  name: 'PrinterDetail',
  emits: ['fetch-data'],
  data() {
    return {
      printerId: '',
      showForm: {},
      testForm: {
        content: '',
      },
      dialogFormVisible: false,
      testVisible:false
    }
  },
  methods: {
    bindPrinter() {
      this.$baseConfirm(
        `你确定要绑定打印机：${this.showForm.title} 吗`,
        null,
        async () => {
          await bindPrinter({ printerId: this.printerId })
          this.$baseMessage(
            `绑定打印机成功`,
            'success',
            false,
            'vab-hey-message-success'
          )
        }
      )
    },
    unBindPrinter() {
      this.$baseConfirm(
        `你确定要解绑打印机：${this.showForm.title} 吗`,
        null,
        async () => {
          await unBindPrinter({ printerId: this.printerId })
          this.$baseMessage(
            `解绑打印机成功`,
            'success',
            false,
            'vab-hey-message-success'
          )
        }
      )
    },
    testPrinter() {
      this.testVisible = true
      this.testForm.content = ''
    },
    submitTest() {
      this.$baseConfirm(
        `你确定要测试打印机：${this.showForm.title} 吗`,
        null,
        async () => {
          await testPrinter({ printerId: this.printerId,content:this.testForm.content })
          this.$baseMessage(
            `测试打印机成功`,
            'success',
            false,
            'vab-hey-message-success'
          )
          this.testVisible = false
        }
      )
    },
    async show(row) {
      const printerId = row.printerId
      const data = await findPrinter({
        printerId,
      })
      this.printerId = printerId
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
